<template>
  <div v-if="visible" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content">
      <button class="close-btn" @click="closeModal">&times;</button>
      
      <h5>{{ title }}</h5>
      <p>{{ message }}</p>

      <div class="modal-buttons d-flex justify-content-center gap-2">
        <button v-if="showCancel" class="btn-cancel" @click="$emit('cancel')">
          {{ cancelText || 'إلغاء' }}
        </button>
        <button v-if="showConfirm" class="btn-confirm" @click="$emit('confirm')">
          {{ confirmText || 'تأكيد' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    title: String,
    message: String,
    showCancel: {
      type: Boolean,
      default: false,
    },
    showConfirm: {
      type: Boolean,
      default: true,
    },
    confirmText: {
      type: String,
      default: 'تأكيد',
    },
    cancelText: {
      type: String,
      default: 'إلغاء',
    },
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000; /* Ensure the modal is on top */
}

.modal-content {
  background: white;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
  width: 90%; /* Responsive width */
  max-width: 400px; /* Max width for larger screens */
  position: relative; /* For positioning the close button */
}

.close-btn {
  position: absolute;
  top: 10px;
  left: 15px;
  background: none;
  border: none;
  font-size: 1.5rem;
  font-weight: bold;
  cursor: pointer;
  color: #888;
}

.modal-content h5 {
  font-size: 1.25rem;
  margin-bottom: 15px;
}

.modal-content p {
  font-weight: 600;
  margin-bottom: 20px;
}

.modal-buttons button {
  width: fit-content;
  border: none;
  border-radius: 5px;
  padding: 8px 20px;
  cursor: pointer;
  font-weight: bold;
}

.btn-confirm {
  background: rgb(250, 175, 67);
  color: #fff;
}

.btn-cancel {
  background: #e3e3e3;
  color: #5b5b5b;
}

/* Optional: add hover effects */
.btn-confirm:hover {
  opacity: 0.9;
}

.btn-cancel:hover {
  background: #d4d4d4;
}
</style>